const taxPaths = {
  TAX: "",
  SEARCH_TAX_LIST: "search",
  TAX_ID: (id) => id,
  MEWS_TAX_RATES: "mews-tax-rates",
};

export default taxPaths;
